import { put, takeEvery } from 'redux-saga/effects';
import {
  fetchCouponsSuccess,
  fetchCouponsFailure,
  setAnyData,
  fetchSingleCouponSuccess,
  fetchSingleCouponFailure
} from 'redux/coupon/actions';
import request from 'utils/request';
import urls from 'utils/config';
import CouponsActionTypes from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { API_BASE_URL } = urls || {};

export function* fetchCoupons({ payload }) {
  const url = `${API_BASE_URL}/coupons?page=${
    +payload.currentPage || 0
  }&size=${+payload.pageSize || 10}&keyword=${payload.keyword || ''}`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(fetchCouponsSuccess(response.raw));
    yield put(setAnyData({ filterOn: payload.keyword ? true : false }));
  } else {
    networkErrorHandler(response?.statusCode, `Failed to Fetch Coupons: ${response.message}`);
    yield put(fetchCouponsFailure(response.message));
  }
}

export function* getCoupons() {
  yield takeEvery(CouponsActionTypes.START_FETCH_COUPONS, fetchCoupons);
}

export function* fetchSingleCoupon({ payload: { id, data } }) {
  const url = `${API_BASE_URL}/coupons/${id}/items?page=${
    +data.currentPage || 0
  }&size=${+data.pageSize || 10}&keyword=${data.keyword || ''}`;
  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(fetchSingleCouponSuccess(response.raw));
  } else {
    yield put(fetchSingleCouponFailure(response.message));
  }
}

export function* onGetSingleCoupon() {
  yield takeEvery(
    CouponsActionTypes.FETCH_SINGLE_COUPON,
    fetchSingleCoupon
  );
}